<template>
  <section>
    <div v-for="item in filterListing" :key="item.id">
      <div class="flex justify-between">
        <p class="text-gray-dark text-md font-medium mb-2 tracking-wider">
          {{ item.label }}
        </p>
      </div>
      <div>
        <div
          class="grid md:grid-cols-3 grid-cols-2 gap-4"
          v-if="item.type === 'button'"
        >
          <div
            v-for="option in item.options"
            :key="option.value + Math.random().toString()"
            class="px-2"
          >
            <button
              type="button"
              class="text-gray-dark focus:outline-none ring-1 ring-gray-300 px-2 py-1 hover:border-gray-dark hover:text-green-light rounded-lg"
              :class="{
                'text-green-light text-md':
                  item.value === option.value ||
                  (item.id && option.id && item.id === option.id) ||
                  checkIfSelected(option.value),
              }"
              @click="addElementToFiltersApplied(item.key, option, item.type)"
            >
              {{ option.label }}
            </button>
          </div>
        </div>
        <div v-if="item.type === 'checkboxAndSearch'">
          <label
            v-for="option in item.options"
            class="flex items-center text-gray-dark text-sm"
            :key="option.value + Math.random().toString()"
          >
            <input
              type="checkbox"
              class="text-green-light"
              :checked="item.value[option.label]"
              @change="handleFilterChange(item.key, option.value, item.type)"
            />
            <span class="ml-2">{{ option.label }}</span>
          </label>
        </div>
      </div>
      <div class="border-blue-light border-b my-2"></div>
    </div>
  </section>
</template>
<script>
export default {
  name: "SideBarFilter",
  props: {
    filterListing: Array,
    handleFilterChange: Function,
  },
  data() {
    return {
      filtersApplied: [],
      selectedFilter: [],
    };
  },
  methods: {
    addElementToFiltersApplied(key, option, type) {
      this.filterListing.forEach((ele) => {
        if (key === ele.key) {
          ele.options.forEach((element) => {
            if (element.label === option.label) {
              ele.value = element.value;
            }
          });
        }
      });
      this.selectedFilter.push(option.label);
      const obj = {
        key,
        option,
        type,
      };
      let flag = false;
      this.filtersApplied.forEach((ele) => {
        if (option.label == ele.option.label) {
          flag = true;
        }
      });
      if (!flag) {
        this.filtersApplied.push(obj);
      }
      this.$emit("allFiltersApplied", this.filtersApplied);
    },

    checkIfSelected(value) {
      return this.selectedFilter.includes(value);
    },
  },
};
</script>